// Anglar
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { APP_CONFIG, AppConfig } from './config/app.config';
import { BrowserStorageService } from './services/browser-storage.Service';
import { AlertService } from './services/alert.service';
import { AuthGuard } from './auth/services/auth.guard';
import { LoaderInterceptorService } from './interceptors/loader-interceptor.service';
import { NavigationService } from './services/navigation.service';
import { SupportSidebarService } from './services/support-sidebar.service';
import { VerificationGuard } from './auth/services/verification.guard';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		TranslateModule.forChild()
	],
	providers: [
		DatePipe,
		// { provide: ErrorHandler, useClass: AppErrorHandler },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoaderInterceptorService,
			multi: true
		},
		{
			provide: APP_CONFIG,
			useValue: AppConfig
		},
		BrowserStorageService, AlertService, AuthGuard, VerificationGuard, NavigationService, SupportSidebarService
	]
})
export class CoreModule { }
